module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag user_tag",
    class: {
      'cursor-pointer': _vm.clickUser,
      fitContent: _vm.fitContent
    },
    on: {
      "click": function($event) {
        _vm.clickUser ? _vm.gotoUser() : ''
      }
    }
  }, [(_vm.showAvatar) ? _c('div', {
    staticClass: "tag__image",
    style: (("background-image: url(" + (_vm.user.avatar.url) + ");width: " + _vm.width + "px;height: " + _vm.height + "px; margin-right: " + (_vm.marginRight ? _vm.marginRight : '')))
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bio-wrapper"
  }, [(!_vm.hideName) ? _c('div', {
    staticClass: "tag__name text-capitalize"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _vm._e(), _vm._v(" "), (_vm.showUserType) ? _c('div', {
    staticClass: "tag__usertype text-capitalize"
  }, [_vm._v(_vm._s(_vm.user.user_type))]) : _vm._e()]), _vm._v(" "), (['artist', 'label', 'brand'].indexOf(_vm.user.user_type) > -1 && !_vm.hideTick) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d1546c5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user_tag.vue
// module id = 1609
// module chunks = 180